import { DEFAULT_CURRENCY, priceCurrencyValues } from '../../domain/constants';
import { z } from 'zod';

export const myLQATierVariantCreateSchema = z.object({
	pricingPerMonth: z
		.record(
			z.enum(priceCurrencyValues),
			z
				.number()
				.nonnegative('Price must be a positive number')
				.max(100000, 'Price value cannot be bigger than 100000 ')
				.optional()
		)
		.refine(
			(data) =>
				data[DEFAULT_CURRENCY] !== undefined && data[DEFAULT_CURRENCY] !== null,
			{
				error: `${DEFAULT_CURRENCY} pricing is required`,
				path: [DEFAULT_CURRENCY],
			}
		),
	includedSeats: z
		.number()
		.int()
		.positive('Number of seats must be a positive number'),
	tierId: z.string().uuid(),
	hotelId: z.number().optional(),
	brandId: z.number().optional(),
});

export const myLQATierVariantUpdateSchema = myLQATierVariantCreateSchema
	.partial()
	.omit({
		pricingPerMonth: true,
		tierId: true,
		hotelId: true,
		brandId: true,
	})
	.merge(
		z.object({
			state: z.enum(['archived']).optional(),
		})
	);
